//const type = "USER/";

export const guestConstants = {
  //#region User login/logout Constants
  REGISTER_REQUEST: "REGISTER_REQUEST",
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  REGISTER_FAILURE: "REGISTER_FAILURE",

  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",


  EMAIL_EXIST_SUCCESS: "EMAIL_EXIST_SUCCESS",
  EMAIL_EXIST_FAILURE: "EMAIL_EXIST_FAILURE",
  EMAIL_EXIST_REQUEST: "EMAIL_EXIST_REQUEST",
  //#endregion

  //#region set/forget password constants
  SET_PASSWORD_REQUEST: "SET_PASSWORD_REQUEST",
  SET_PASSWORD_SUCCESS: "SET_PASSWORD_SUCCESS",
  SET_PASSWORD_FAILURE: "SET_PASSWORD_FAILURE",

  VALIDATE_PASSWORD_TOKEN_REQUEST: "VALIDATE_PASSWORD_TOKEN_REQUEST",
  VALIDATE_PASSWORD_TOKEN_SUCCESS: "VALIDATE_PASSWORD_TOKEN_SUCCESS",
  VALIDATE_PASSWORD_TOKEN_FAILURE: "VALIDATE_PASSWORD_TOKEN_FAILURE",

  FORGOTPWD_REQUEST: "FORGOTPWD_REQUEST",
  FORGOTPWD_SUCCESS: "FORGOTPWD_SUCCESS",
  FORGOTPWD_FAILURE: "FORGOTPWD_FAILURE",
  //#endregion
};